module.exports = __webpack_public_path__ + "img/minting_process.9bf3d38b.png";